export const data = [
  {
    id: 1,
    receiptNumber: "01Rep012302",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012302",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012302",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012303",
    transactionCode: "123457",
    transactionNumber: "Transac00124",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012307",
    transactionCode: "123456",
    transactionNumber: "Transac00129",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012307",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012302",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012301",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012302",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
  {
    id: 1,
    receiptNumber: "01Rep012302",
    transactionCode: "123456",
    transactionNumber: "Transac00123",
    name: "Name",
    customerCode: "CC0102",
    date: "11/12/2023",
    amount: "500.37",
    action: "Action",
  },
     
  ];